/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChiusuraCompensoDTO
 */
export interface ChiusuraCompensoDTO {
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoDTO
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoDTO
     */
    sequenza?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoDTO
     */
    descrizione?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ChiusuraCompensoDTO
     */
    importo?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoDTO
     */
    bold?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ChiusuraCompensoDTO
     */
    color?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ChiusuraCompensoDTO
     */
    esclusoDaTotale?: boolean;
}

/**
 * Check if a given object implements the ChiusuraCompensoDTO interface.
 */
export function instanceOfChiusuraCompensoDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ChiusuraCompensoDTOFromJSON(json: any): ChiusuraCompensoDTO {
    return ChiusuraCompensoDTOFromJSONTyped(json, false);
}

export function ChiusuraCompensoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChiusuraCompensoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'sequenza': !exists(json, 'sequenza') ? undefined : json['sequenza'],
        'descrizione': !exists(json, 'descrizione') ? undefined : json['descrizione'],
        'importo': !exists(json, 'importo') ? undefined : json['importo'],
        'bold': !exists(json, 'bold') ? undefined : json['bold'],
        'color': !exists(json, 'color') ? undefined : json['color'],
        'esclusoDaTotale': !exists(json, 'esclusoDaTotale') ? undefined : json['esclusoDaTotale'],
    };
}

export function ChiusuraCompensoDTOToJSON(value?: ChiusuraCompensoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sequenza': value.sequenza,
        'descrizione': value.descrizione,
        'importo': value.importo,
        'bold': value.bold,
        'color': value.color,
        'esclusoDaTotale': value.esclusoDaTotale,
    };
}

